/* eslint-disable no-restricted-globals */

import { delay, takeEvery, takeLatest, select, call, put } from "redux-saga/effects";
import { browserHistory } from "react-router";
import { change, SubmissionError } from "redux-form";
import keys from "lodash/keys";
import pickBy from "lodash/pickBy";
import includes from "lodash/includes";
import some from "lodash/some";
import Flat, { unflatten } from "flat";
import Papa from "papaparse";

import * as sagasCommon from "../../sagasCommon";
import * as apiCommon from "../../../services/apiCommon";
import * as apiAdmin from "../../../services/apiAdmin";
import * as apiInventoryStocktake from "../../../services/inventory/stocktake/api_inventory_stocktake";
import {
  FETCH_LIST_INVENTORY_STOCKTAKE,
  SAVE_INVENTORY_STOCKTAKE,
  GET_INVENTORY_STOCKTAKE,
  DELETE_INVENTORY_STOCKTAKE,
  DELETE_INVENTORY_STOCKTAKE_FROM_LIST,
  GET_INVENTORY_STOCKTAKE_ITEM_LOCATIONS,
  EXPORT_STOCKTAKE_TO_DOC
} from "../../../constants/constant_saga_types";
import {
  SET_STOCKTAKE_PREFERENCES,
  SET_STOCKTAKE_FORM_LINE_PAGINATION,
  IMPORT_FROM_DOC,
  SET_TRANSACTION_STATUS_LIST
} from "../../../constants/constant_action_types";
import { InventoryStocktakeForm } from "../../../constants/constant_form_names";
import {
  PROCESSING,
  OPEN,
  PENDING_APPROVAL,
} from "../../../constants/constant_transaction_status";
import { getParticularPreferenceSettings } from "../../../common/selectors/preference";
import * as utilityPreference from "../../../services/preference/utilty_preference";
import {
  getLocationId,
  getFormLines,
  getTransactionStatusOpen
} from "../../../components/admin/inventory_management/stocktake/InventoryStocktakeSelector";

import { immediateDownload } from "../../../actions/actionCreatorsDownloader";
import { tablePadder } from "../../../utils/index";
 




// Common candidate. Copied from saga_inventory_transfer
export function* fetchTransactionStatusList(feathersApp, action) {
  const { fields, included_status } = action;
  const transactionStatusList = yield call(apiAdmin.fetchTransactionStatusDropdown, feathersApp, {
    fields,
    searchParams: { included_status }
  });
  yield put({ type: SET_TRANSACTION_STATUS_LIST, transactionStatusList });
}






export function* getInventoryStocktakeSaga( feathersApp ) {
  yield takeEvery( GET_INVENTORY_STOCKTAKE, callGetInventoryStocktake, feathersApp );
}

export function* callGetInventoryStocktake( feathersApp, action ) {
  try {
    yield sagasCommon.showProgressDataById();
    const { user, intl, tenant } = yield select();
    const { id } = action;
    const { subsidiary_details={}, employee_primary_location_id } = user;
    const locationId = employee_primary_location_id;
    const subsidiaryId = ( ( subsidiary_details || {} ).subsidiary || {} ).id;

    const params = {
      settings: [
        'default_barcode_average_time_per_character',
        'default_barcode_minimum_barcode_length',
        'default_barcode_time_before_scan_test',
        'enable_item_part_quantity',
      ],
      locationId,
      subsidiaryId,
      accountId: (tenant|| {}).id,
      intl
    };
    const preferences = yield call( utilityPreference.getPreferenceValues, feathersApp, params );
    yield put( { type: SET_STOCKTAKE_PREFERENCES, preferences } );

    if( id ) {
      const result = yield call( apiInventoryStocktake.fetchInventoryStocktakeById, feathersApp, { id, user } );
      let data = { ...result };

      if( result.status.cid === OPEN || result.status.cid === PENDING_APPROVAL ){
        data.enter_unit_cost = result.lines.some( line => { return !!line.unit_cost; } );
      }

      yield sagasCommon.doneDataById(data);
    } else {
      const transactionStatusOpen = yield select(getTransactionStatusOpen);
      const data = { status_id: transactionStatusOpen.id, status: transactionStatusOpen, stocktake_type: 'partial' };
      yield sagasCommon.doneDataById(data);
    }

    const { value } = yield select( getParticularPreferenceSettings, 'search_default_rows_count_list', 'value' );
    const perPage = value || 10;
    yield put( { type: SET_STOCKTAKE_FORM_LINE_PAGINATION, pagination: { page: 1, perPage } } );

  } catch ( e ) {
    console.error(e.stack);
    yield sagasCommon.showErrorDataById( e, true );
  }
}







export function* deleteInventoryStocktakeSaga( feathersApp ) {
  yield takeEvery( DELETE_INVENTORY_STOCKTAKE, callDeleteInventoryStocktake, feathersApp );
}

export function* callDeleteInventoryStocktake( feathersApp, action  ) {
  const result = yield deleteInventoryStocktake( feathersApp, action );
  yield delay(2000);
  if( result ){
    browserHistory.push( '/admin/inventory/stocktake' );
  }
}






export function* deleteInventoryStocktakeFromListSaga( feathersApp ) {
  yield takeEvery( DELETE_INVENTORY_STOCKTAKE_FROM_LIST, callDeleteInventoryStocktakeFromList, feathersApp );
}

export function* callDeleteInventoryStocktakeFromList( feathersApp, action ){
  yield deleteInventoryStocktake( feathersApp, action );
  yield delay(2000);
  yield callFetchListInventoryStocktake( feathersApp, { silent: true } );
}






export function* deleteInventoryStocktake( feathersApp, action ){
  yield sagasCommon.showProgressDeleteRecord();
  try {
    const { id } = action;
    let result = null;
    if ( id ) {
      const state = yield select();
      const { tenant, user } = state;
      const params = { tenant, user, id };
      result = yield call( apiInventoryStocktake.deleteInventoryStocktake, feathersApp, params );
      yield sagasCommon.doneDeleteRecord( id, 'inventory_stocktake' );
    }
    return result;
  } catch (e) {
    console.error(e.stack);
    yield sagasCommon.showErrorDeleteRecord(e);
  }
}










export function* saveInventoryStocktakeSaga( feathersApp ) {
  yield takeEvery( SAVE_INVENTORY_STOCKTAKE, callSaveInventoryStocktake, feathersApp );
}

export function* callSaveInventoryStocktake( feathersApp, action ) {
  try {
    const { user } = yield select();
    const { data } = action;

    if( data.status.cid === PROCESSING ){

      const isQtyFilledUp = ( data.lines || [] ).every( line => {
        return line.new_quantity;
      } );

      const isFullStocktake = data.stocktake_type === 'full';
      if( isFullStocktake && !isQtyFilledUp ){
        const ok = confirm( 'Currently on full stocktakes, are you sure you want to proceed?' );
        if( !ok ) return;
      }

      const locationId = data.location.id;
      const countedLines = data.lines.filter( line => { return Boolean( line.new_quantity ); } );
      const itemIds = countedLines.map( line => { return line.item.id; } );

      let itemLocationLines = [];
      if( countedLines.length ) {
        itemLocationLines = yield call( apiInventoryStocktake.getItemLocation, feathersApp, { locationId, itemIds } );
      }
      
      const diffOnhandLines = getDiffOnhand( countedLines, itemLocationLines );
      if( diffOnhandLines.length ){
        const ok = confirm( 'On hand values has been changed. Do you want to proceed?' );
        if( !ok ) {
          yield call( updateCountedLines, data.lines, diffOnhandLines );
          throw new SubmissionError( { lines: "On hand values has been changed" } );
        }
      } 
    }  
    
    yield sagasCommon.showProgressSaveRecord();    
    let result = yield call( apiInventoryStocktake.saveInventoryStocktake, feathersApp, { user, data } );
    const id = result.id || result._id;

    // pagedLines (see InventoryStocktakeFormLines.js and InventoryStocktakeFormLinesPaginator.js) caches
    // on mount only (once).
    // Saving new records results in double fetch.
    // Double fetching results in differing generated lines for
    // pagedLines and InventoryStocktakeForm lines resulting in "No Lines" displayed.
    if (data._id) {
      yield put( { type: GET_INVENTORY_STOCKTAKE, id } );
    }

    browserHistory.push( `/admin/inventory/stocktake/edit/${ id }` );
    yield sagasCommon.doneSaveRecord( null, "Inventory stocktake was saved" );
  } catch ( e ) {
    console.error(e.stack);
    yield sagasCommon.showErrorSaveRecord( e );
  }
}


function* updateCountedLines( newLines, diffOnhandLines ){
  yield diffOnhandLines.map( line => {
    const index = newLines.findIndex( findLine( line.item.id ) );
    return put( change( InventoryStocktakeForm, `lines[${ index }].new_current_quantity`, line.current_quantity ) );
  });
}


function findLine( itemId ) {
  return function( line ){
    return line.item.id === itemId;
  }
}


function getDiffOnhand( newLines, oldLines ) {
  return oldLines.filter( oldLine => {
    let hasDiffOnhand = false;

    newLines.forEach( newLine => {
      if( newLine.item.id === oldLine.item.id ){
        hasDiffOnhand = newLine.current_quantity !== oldLine.current_quantity;
      }
    } );

    return hasDiffOnhand;
  } );
}







export function* fetchListInventoryStocktakeSaga( feathersApp ) {
  yield takeLatest( FETCH_LIST_INVENTORY_STOCKTAKE, callFetchListInventoryStocktake, feathersApp );
}

export function* callFetchListInventoryStocktake( feathersApp, action ) {
  try {
    const { silent, filter } = action;
    yield sagasCommon.showProgressListTable( silent );
    const dataParams = {
      filters: { ...filter, control_type: 'stocktake' },
      list_type: 'inventory_stocktake'
    };
    
    const tableData = yield call( apiCommon.getDocs, feathersApp, dataParams );
    yield call( sagasCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total } );
  } catch ( e ) {
    console.error(e.stack);
    yield sagasCommon.showErrorListTable( e );
  }
}








export function* getInventoryStocktakeItemLocationsSaga( feathersApp ){
  yield takeEvery( GET_INVENTORY_STOCKTAKE_ITEM_LOCATIONS, callGetInventoryStocktakeItemLocationsSaga, feathersApp );
}

export function* callGetInventoryStocktakeItemLocationsSaga( feathersApp, action ){
  try {
    yield put(change(InventoryStocktakeForm, "isFetchingItemLocations", true));
    const { user } = yield select();
    const { locationId } = action;
    const itemLocationResults = yield call( apiInventoryStocktake.getItemLocation, feathersApp, { locationId, user } );
    yield put(change(InventoryStocktakeForm, "lines", itemLocationResults));
    yield put(change(InventoryStocktakeForm, "isFetchingItemLocations", false));
  } catch( e ){
    console.error(e.stack);
    yield sagasCommon.showErrorSaveRecord( e )
  }
}








export function* exportToDoc( feathersApp ) {
  yield takeEvery( EXPORT_STOCKTAKE_TO_DOC, callExportToDoc, feathersApp );
}

export function* callExportToDoc( feathersApp, action ) {
  try {
      // get neccessary variables
      const { formLines } = action.payload;

      // Explicitly define table, its columns, and default values
      const tableBase = {
        'item.name': '',
        'current_quantity': 0,
        'new_quantity': 0,
        'unit_cost': 0,
        'comment': ''
      };
    
      // Define a map for returning export fields
      const exportReturnMap = keys(tableBase);
    
      // Obtain neccessary fields (based from exportReturnMap)
      // ---- POSSIBLE OPTIMIZATION: remove flattening, access fields directly;
      // ---- flattening all lines and properties for accessing is easier but costly
      const flattedFormLines = (formLines || []).map(formLine => {
        const flattedFormLine = Flat(formLine);

        // Format formline as based on tableBase
        const formattedFlattedFormLine = { ...tableBase, ...flattedFormLine };
    
        // Filter columns via exportReturnMap
        let fFlattedFormLine = pickBy(formattedFlattedFormLine, (value, key) => {
          return includes(exportReturnMap, key) ? true : false;
        });
        
        // Override new_quantity value if 0. Used for import csv
        fFlattedFormLine['new_quantity'] = fFlattedFormLine['new_quantity'] || '';
        return fFlattedFormLine;
      });
    
      // Padd table data first to remove "holes",
      // in preparation for CSV parsing using papaparse
      const paddedFlattedFormLines = tablePadder(flattedFormLines);

      // Parse to CSV
      const formLinesCsv = Papa.unparse(paddedFlattedFormLines);

      // Encode for transporting
      const encodedFormLinesCsv = encodeURIComponent(formLinesCsv);

      yield put(immediateDownload( `${encodedFormLinesCsv}`, true, 'csv', 'stocktake' ));
  } catch ( e ) {
    console.error(e);
  }
}





export function* importFromDoc( feathersApp ) {
  yield takeEvery( IMPORT_FROM_DOC, callImportFromDoc, feathersApp );
}

export function* callImportFromDoc( feathersApp, action ) {
  try {
    // ---- POSSIBLE OPTIMIZATION:
    // ---- Remove flattening on data intersection (by item.name) union
    // TODO: importType handler, implement as needed

    // test for locationId
    const locationId = yield select(getLocationId);
    if ( !locationId ) return;

    // get neccessary variables
    const lines = yield select(getFormLines);
    const data = action.payload;
    
    // Define a map for checking fields
    const importReturnMap = [
      'item.name', // needed for referencing, must be unique
      'new_quantity',
      'is_counted', // only if count not null; only if >= 0
      'quantity', // (z = y - x, where z = variance, y = new_quantity, x = current_quantity)
      // 'reason_code.id', // Removed can introduce foreign key exception and currently doesn't show name
      'comment',
      'unit_cost'
    ];
    
    // data is raw, parse to object
    const parsedData = Papa.parse( data );
    
    // Format parsed data to table formatting
    // ({ accessorField: value[, accessorField2: value[, ...]] })
    // TODO: seprate to a utility
    const parsedDataHeaders = parsedData.data[0];
    const fData = (parsedData.data.slice(1) || []).map(entry => {
      const fParsedData = {};
      
      (entry || []).forEach(( value, index ) => {
        // Perform pre intersection union operation(s)
        if ( includes( importReturnMap, parsedDataHeaders[ index ] ) )
          fParsedData[ parsedDataHeaders[ index ] ] = value;
      });
    
      return fParsedData;
    });
    
    // Perform current data and import data intersection union
    // TODO: seperate to a utility
    const currData = (lines || []).map(entry => Flat( entry ));
    
    // ---- POSSIBLE OPTIMIZATION: weigh fCurrData (fCurrData > 0) vs data, then set for looping
    const fCurrData = (currData || []).map(( currDatum, currDatumKey ) => {
      let fCurrDatum = currDatum;

      some(fData, ( fDatum, fDatumKey ) => {
        if (currDatum[ 'item.name' ] === fDatum[ 'item.name' ]) {
          fCurrDatum = {
            ...currDatum,
            ...fDatum
          };

          // Perform post intersection union operations(s)

          // Check for count and adjust is_counted accordingly
          if (
            fCurrDatum.new_quantity >= 0 &&
            fCurrDatum.new_quantity !== null &&
            fCurrDatum.new_quantity !== undefined &&
            fCurrDatum.new_quantity !== ""
          ) {
            fCurrDatum.is_counted = true;
          }

          // compute for variance (z = y - x, where z = variance)
          const y = Math.abs(fCurrDatum.new_quantity);
          const x = fCurrDatum.current_quantity;

          fCurrDatum.quantity = y - x;
        }
      });

      return fCurrDatum;
    } );

    const fCurrDataObj = (fCurrData || []).map(entry => unflatten(entry));

    yield put( change( InventoryStocktakeForm, 'lines', fCurrDataObj ) );
  } catch ( e ) {
    console.error( e );
  }
}
